/**
 * Renders either an introduction or results based on the current position.
 */
import React, { PropTypes } from 'react';
import Intro from './Intro';
import Result from './Result';

function IntroOrResult({
  answers,
  assessmentData,
  clearAssessmentResults,
  currentPosition,
  emailOverlay,
  emailResults,
  emailSent,
  nextStep,
  previousStep,
  questions,
  readingListItems,
  resultUserEmail,
  setResult,
  toggleEmailOverlay,
}) {
  const startAssessment = (currentPosition === -1);
  const introText = assessmentData[0].fieldIntroText[0].value;
  const actionButton = assessmentData[0].fieldActionButton[0].value;
  const title = assessmentData[0].title[0].value;
  return (
    <div>
      {startAssessment ?
        <Intro
          actionButton={actionButton}
          disabled={!questions}
          introText={introText}
          nextStep={nextStep}
          previousStep={previousStep}
          title={title}
        />
        :
          <Result
            answers={answers}
            assessmentData={assessmentData}
            clearAssessmentResults={clearAssessmentResults}
            emailOverlay={emailOverlay}
            emailResults={emailResults}
            emailSent={emailSent}
            previousStep={previousStep}
            questions={questions}
            readingListItems={readingListItems}
            resultUserEmail={resultUserEmail}
            setResult={setResult}
            toggleEmailOverlay={toggleEmailOverlay}
          />
      }
    </div>
  );
}

IntroOrResult.propTypes = {
  answers: PropTypes.shape({}),
  assessmentData: PropTypes.arrayOf(PropTypes.shape({})),
  clearAssessmentResults: PropTypes.func,
  currentPosition: PropTypes.number,
  emailOverlay: PropTypes.bool,
  emailResults: PropTypes.func,
  emailSent: PropTypes.bool,
  nextStep: PropTypes.func,
  previousStep: PropTypes.func,
  questions: PropTypes.arrayOf(PropTypes.shape({})),
  readingListItems: PropTypes.arrayOf(PropTypes.shape({})),
  resultUserEmail: PropTypes.string,
  setResult: PropTypes.func,
  toggleEmailOverlay: PropTypes.func,
};

export default IntroOrResult;



// WEBPACK FOOTER //
// js/src/assessment/IntroOrResult.js